import { Button, ButtonGroup, makeStyles, useTheme } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CloseIcon from "@material-ui/icons/Close";
import DeleteForever from "@material-ui/icons/DeleteForever";
import React from "react";

const Transition = React.forwardRef(function Transition(
   props: TransitionProps & { children?: React.ReactElement<any, any> },
   ref: React.Ref<unknown>,
) {
   return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
   label: {
      flexDirection: "column",
      fontSize: "11px",
   },
}));

export const DeleteContactDialog: React.FC<any> = (props: {
   title: string;
   text: string;
   open: boolean;
   handleDelete: () => void;
   handleClose: () => void;
}): JSX.Element => {
   const classes = useStyles();
   const theme = useTheme();
   const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

   const deleteTitle = props.title || "Deactivate?";
   const deleteText = props.text || "You are about to deactivate this contact do you want to continue?";

   return (
      <Dialog open={props.open || false} TransitionComponent={Transition} keepMounted fullScreen={mobileScreen}>
         <DialogTitle style={{ backgroundColor: "#002D72", color: "white", textAlign: "center" }}>
            {deleteTitle}
         </DialogTitle>
         <DialogContent>
            <DialogContentText>{deleteText}</DialogContentText>
         </DialogContent>
         <DialogActions>
            <ButtonGroup>
               <Button
                  onClick={props.handleClose}
                  variant="contained"
                  classes={{
                     label: classes.label,
                  }}
               >
                  <CloseIcon />
                  Close
               </Button>
               <Button
                  onClick={props.handleDelete}
                  variant="contained"
                  color="secondary"
                  classes={{
                     label: classes.label,
                  }}
               >
                  <DeleteForever />
                  Deactivate
               </Button>
            </ButtonGroup>
         </DialogActions>
      </Dialog>
   );
};

export default DeleteContactDialog;
